// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PopularSearch_wrapper__aD9Ad","popular-search-list":"PopularSearch_popular-search-list__f_OSZ"};